export enum EPartners {
  'elama' = 'elama',
}
